{
  "slTp": {
    "price": "Цена",
    "stopLossShort": "SL",
    "stopLoss": "Stop Loss",
    "takeProfitShort": "TP",
    "takeProfit": "Take Profit",
    "close": "Закрыть"
  }
}
